<template lang="pug">
.container(id="UUIDSelector-container")
  h4(v-if='header') {{ header }}
  hr.header(v-if='header')
  el-form(id="UUIDSelector-form" label-width="130px")
    p {{ $t('New UUID:') }}
    el-input.el-input(id="UUIDSelector-UUIDInput" v-model='params.UUID', type="text", name="UUID", ref="UUID", :placeholder="$t('uuid')", @input='handleUUIDInputChange()')
    el-button.float-right(
      :id="'SearchByUUID-changeUUIDDesktop'",
      type='success',
      size='mini',
      :disabled='params.UUID.length < 3',
      :title="$t('Change UUID')",
      @click="changeUUID()"
    )
      span {{ $t('Change UUID and re-provision device') }} &nbsp;
      font-awesome-icon(icon="save")
  br
  p.error(v-if='!(params.UUID.length < 3) && uuidsUnknown.length > 0') {{ $t('Following UUIDs where found in Unknown UUIDs table, click on proper one:') }}
  table(v-if='!(params.UUID.length < 3) && uuidsUnknown.length > 0')
    tr(v-for='uuid in uuidsUnknown', :key='uuid.id', :id="'UUIDSelector-formTableRowuuid' + uuid.id")
      td
        span.uuid(@click='params.UUID = uuid.uuid') {{ uuid.uuid }} &nbsp;
          font-awesome-icon(icon="copy", :title='$t("Click to use this UUID")')
  p.error(v-if='errors.length > 0 && uuidsUnknown.length === 0' id="UUIDSelector-notFoundError")
    span {{ $t('No such UUID found in Unknown UUIDs table.') }}
  p.error(v-if='!(params.UUID.length < 3) && uuidsKnown.length > 0') {{ $t('Following UUIDs where found in Existing screens UUIDs table, and you cannot use them:') }}
  table(v-if='!(params.UUID.length < 3) && uuidsKnown.length > 0')
    tr(v-for='uuid in uuidsKnown', :key='uuid.id', :id="'UUIDSelector-formTableRowuuidKnown' + uuid.id")
      td
        span.uuid {{ uuid.uuid }}
  p.error(v-if='errors.length > 0 && uuidsUnknown.length === 0' id="UUIDSelectorKnown-notFoundError")
    span {{ $t('No such UUID found in Existing screens table.') }}
  ConfirmDialog(
    id="UUIDSelector-confirmDialog",
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
</template>
<script>
import Vue from 'vue'
import ConfirmDialog from './ConfirmDialog'

export default {
  components: {
    ConfirmDialog
  },
  created () {
    console.log('created')
  },
  props: ['header', 'selectedDesktop'],
  mixins: [
  ],
  data () {
    return {
      errors: [],
      uuidsUnknown: [],
      uuidsKnown: [],
      clientSelected: null,
      params: {
        UUID: ''
      },
      searchURL: 'client',
      confirmDialogQuestion: null,
      confirmDialogVisible: false,
      rightClickData: {}
    }
  },
  methods: {
    async changeUUID () {
      this.confirmDialogQuestion = `${this.selectedDesktop.Device.name} / ${this.selectedDesktop.name} -
      ${this.$t('Are you sure you want change sceen\'sUUID \n and re-provision it')}?`

      this.rightClickData = this.selectedDesktop
      this.confirmDialogVisible = true
    },
    async dialogDenied (data) {
      this.confirmDialogVisible = false
      this.rightClickData = {}
      this.confirmDialogQuestion = null
    },
    async dialogConfirmed () {
      // await this.selectNetworkCommit(network)
      this.errors = []
      this.uuidsUnknown = []
      this.uuidsKnown = []
      this.confirmDialogQuestion = null
      this.confirmDialogVisible = false
      this.rightClickData = {}
      await Vue.axios.post(
        `devicedesktop/changeuuidandreprovision`,
        {
          desktopId: this.selectedDesktop.id,
          uuid: this.params.UUID
        }
      )
      this.params.UUID = ''
      this.$emit('UUIDChanged')
    },
    async handleUUIDInputChange () {
      if (this.params.UUID.length < 3) return null
      await this.__searchForUnknownUUID()
      await this.__searchForKnownUUID()
    },
    async __searchForUnknownUUID () {
      this.errors = []
      this.uuidsUnknown = []
      await Vue.axios.get(
        `uuidunknown?where={"uuid":{"contains":"${this.params.UUID}"}}`
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.uuidsUnknown = response.data
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },
    async __searchForKnownUUID () {
      this.errors = []
      this.uuidsKnown = []
      await Vue.axios.get(
        `devicedesktop?where={"uuid":{"contains":"${this.params.UUID}"}}`
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.uuidsKnown = response.data
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.error {
  color: $--color-warning;
}
table {
  margin-left: 0px;
  padding: 0px;
  border-spacing: 0px;
  padding: 0px;
  // max-width: 90%;
  tr {
    th, td {
      border-bottom: $--border-light;
    }
    th {
      p {
        margin-right: 20px;
      }
    }
    .uuid {
      cursor: pointer;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Common/UUIDSelector.vue